import { HttpClient, HttpParams } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import {
  BulkProxyResultResponse,
  CreateProxyRequest,
  ListProxiesQuery,
  ListProxiesResponse,
  ProxyModel,
  ProxyUsage,
  UpdateProxyRequest,
} from "./proxy.type";

@Injectable({
  providedIn: 'root',
})
export class ProxyService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiBaseURL}/proxies`;

  getProxies(query: ListProxiesQuery = {}): Observable<ListProxiesResponse> {
    let params = new HttpParams();

    if (query.pageSize !== undefined) {
      params = params.set('pageSize', query.pageSize);
    }

    if (query.pageIndex !== undefined) {
      params = params.set('pageIndex', query.pageIndex);
    }

    if (query.search) {
      params = params.set('search', query.search);
    }

    return this.http.get<ListProxiesResponse>(this.apiUrl, { params });
  }

  getProxyUsage(): Observable<ProxyUsage> {
    return this.http.get<ProxyUsage>(`${this.apiUrl}/usage`);
  }

  getProxy(id: string): Observable<ProxyModel> {
    return this.http.get<ProxyModel>(`${this.apiUrl}/${id}`);
  }

  createProxy(request: CreateProxyRequest): Observable<ProxyModel> {
    return this.http.post<ProxyModel>(this.apiUrl, request);
  }

  createProxies(proxies: CreateProxyRequest[]): Observable<ProxyModel[]> {
    return this.http.post<ProxyModel[]>(`${this.apiUrl}/bulk`, { proxies });
  }

  updateProxy(id: string, request: UpdateProxyRequest): Observable<ProxyModel> {
    return this.http.put<ProxyModel>(`${this.apiUrl}/${id}`, request);
  }

  updateProxyActive(id: string, active: boolean): Observable<ProxyModel> {
    return this.updateProxy(id, { active });
  }

  updateProxiesActive(ids: string[], active: boolean): Observable<BulkProxyResultResponse> {
    return this.http.patch<BulkProxyResultResponse>(`${this.apiUrl}/bulk-active`, {
      ids,
      active,
    });
  }

  deleteProxy(id: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }

  deleteProxies(ids: string[]): Observable<BulkProxyResultResponse> {
    return this.http.request<BulkProxyResultResponse>('delete', `${this.apiUrl}/bulk`, {
      body: { ids },
    });
  }
}
